import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { lazy, Suspense } from "react";
import Navigation from "./components/Navigation";
import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/Footer";
import HelpWidget from "./components/HelpWidget";
import Home from "./pages/Home";
const Verhaal = lazy(() => import("./pages/Verhaal"));
const About = lazy(() => import("./pages/About"));
const Pricing = lazy(() => import("./pages/Pricing"));
const Demo = lazy(() => import("./pages/Demo"));
const Contact = lazy(() => import("./pages/Contact"));
const Auth = lazy(() => import("./pages/Auth"));
const NewsDetail = lazy(() => import("./pages/NewsDetail"));
const NotFound = lazy(() => import("./pages/NotFound"));
const VoorLeerlingen = lazy(() => import("./pages/VoorLeerlingen"));
const VoorScholen = lazy(() => import("./pages/VoorScholen"));
const Resultaten = lazy(() => import("./pages/Resultaten"));
const Integratie = lazy(() => import("./pages/Integratie"));
const VeelgesteldeVragen = lazy(() => import("./pages/VeelgesteldeVragen"));

const InformatieOuders = lazy(() => import("./pages/InformatieOuders"));

const Blog = lazy(() => import("./pages/Blog"));
const Cookiebeleid = lazy(() => import("./pages/Cookiebeleid"));
const Status = lazy(() => import("./pages/Status"));
const Voorwaarden = lazy(() => import("./pages/Voorwaarden"));
const LegalDocumentPage = lazy(() => import("./pages/LegalDocumentPage"));
const VoorMentoren = lazy(() => import("./pages/VoorMentoren"));
const LobLeerlijn = lazy(() => import("./pages/LobLeerlijn"));
const AiStudieadvies = lazy(() => import("./pages/AiStudieadvies"));
const Opleidingen = lazy(() => import("./pages/Opleidingen"));
const Testen = lazy(() => import("./pages/Testen"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Dossier = lazy(() => import("./pages/Dossier"));
const Onderbouwing = lazy(() => import("./pages/Onderbouwing"));
const Leerlingprofiel = lazy(() => import("./pages/Leerlingprofiel"));
const HoeWerktHet = lazy(() => import("./pages/HoeWerktHet"));
const PrivacyEnVeiligheid = lazy(() => import("./pages/PrivacyEnVeiligheid"));
import StickyDemoCta from "./components/story/StickyDemoCta";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Navigation />
          <main id="main-content">
          <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/verhaal" element={<Verhaal />} />
            <Route path="/over-ons" element={<About />} />
            <Route path="/prijzen" element={<Pricing />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/nieuws/:id" element={<NewsDetail />} />
            <Route path="/voor-leerlingen" element={<VoorLeerlingen />} />
            <Route path="/voor-scholen" element={<VoorScholen />} />
            <Route path="/resultaten" element={<Resultaten />} />
            <Route path="/integratie" element={<Integratie />} />
            <Route path="/veelgestelde-vragen" element={<VeelgesteldeVragen />} />
            <Route path="/hoe-werkt-het" element={<HoeWerktHet />} />
            <Route path="/informatie-ouders" element={<InformatieOuders />} />
            <Route path="/missie-visie" element={<Navigate to="/over-ons" replace />} />
            <Route path="/voor-mentoren" element={<VoorMentoren />} />
            <Route path="/lob-leerlijn" element={<LobLeerlijn />} />
            <Route path="/keuzehulp" element={<AiStudieadvies />} />
            <Route path="/ai-studieadvies" element={<Navigate to="/keuzehulp" replace />} />
            <Route path="/opleidingen" element={<Opleidingen />} />
            <Route path="/lob-reis" element={<Testen />} />
            <Route path="/testen" element={<Navigate to="/lob-reis" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dossier" element={<Dossier />} />
            <Route path="/onderbouwing" element={<Onderbouwing />} />
            <Route path="/leerlingprofiel" element={<Leerlingprofiel />} />
            <Route path="/privacy-en-veiligheid" element={<PrivacyEnVeiligheid />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/privacy-statement" element={<Navigate to="/voorwaarden/privacyverklaring" replace />} />
            <Route path="/algemene-voorwaarden" element={<Navigate to="/voorwaarden/algemene-voorwaarden" replace />} />
            <Route path="/cookiebeleid" element={<Cookiebeleid />} />
            <Route path="/status" element={<Status />} />
            <Route path="/voorwaarden" element={<Voorwaarden />} />
            <Route path="/voorwaarden/:slug" element={<LegalDocumentPage />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
          </main>
          <Footer />
          <HelpWidget />
           <StickyDemoCta />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
